import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/admin/useAdminVerificationsQuery.ts
var r = (r = {}) => {
	let { status: i, kind: a, removal: o } = r;
	return t({
		queryKey: e.list(i, a, o),
		fetchPage: (e) => n.adminListVerifications({
			status: i,
			kind: a,
			removal: o,
			page: e
		}),
		key: "items"
	});
};
//#endregion
export { r as useAdminVerificationsQuery };
